import createReactComponent from '../createReactComponent';
export default createReactComponent('menu', 'IconMenu', [
  ['path', { d: 'M4 8l16 0', key: 'svg-0' }],
  ['path', { d: 'M4 16l16 0', key: 'svg-1' }],
]);
